module.exports = __webpack_public_path__ + "img/map_left_bg.37479a69.png";